import { useEffect } from 'react';

/**
 * 设置页面标题和社交分享 meta 标签
 * 用于微信/企微等平台的分享卡片预览
 */
export function useShareMetaTags(title: string | undefined, description: string | undefined) {
  useEffect(() => {
    if (!title) return;

    document.title = title;

    const metas: Array<[string, string | undefined]> = [
      ['description', description],
      ['og:title', title],
      ['og:description', description],
    ];

    const created: HTMLMetaElement[] = [];

    metas.forEach(([name, content]) => {
      if (!content) return;

      const isOg = name.startsWith('og:');
      const selector = isOg ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.head.querySelector<HTMLMetaElement>(selector);

      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(isOg ? 'property' : 'name', name);
        document.head.appendChild(meta);
        created.push(meta);
      }

      meta.setAttribute('content', content);
    });

    return () => {
      created.forEach(meta => meta.remove());
    };
  }, [title, description]);
}
